var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-items"},[_vm._t("default"),_c('spinner',{attrs:{"with-overlay":_vm.withOverlay,"large":"","active":_vm.loading}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }